/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_List_Search_PlaceholderInputs */

const en_admin_user_list_search_placeholder = /** @type {(inputs: Admin_User_List_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`email, first name, last name`)
};

const de_admin_user_list_search_placeholder = /** @type {(inputs: Admin_User_List_Search_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail, Vorname, Nachname`)
};

/**
* | output |
* | --- |
* | "email, first name, last name" |
*
* @param {Admin_User_List_Search_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_list_search_placeholder = /** @type {((inputs?: Admin_User_List_Search_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_List_Search_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_list_search_placeholder(inputs)
	return en_admin_user_list_search_placeholder(inputs)
});